import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'

const sponsorRelationWatch = (options) => {
  const familyRelationShipIdWatch = ref()
  const formStore = useFormStore()

  familyRelationShipIdWatch.value = watch(
    () => formStore.form.values.familyRelationShipId,
    (newVal) => {
      if (!newVal || !options.value) return
      const relation = options.value.find((relation) => relation.id == newVal)
      formStore.form.setFieldValue('genderId', relation?.genderId)
    }
  )
  onUnmounted(() => {
    familyRelationShipIdWatch.value && familyRelationShipIdWatch.value()
  })
}
export default function () {
  return {
    sponsorRelationWatch
  }
}
